// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2MWJp","footer":"ModalInfo_footer__2ZI_N"};